import { gql } from '@apollo/client';

export default gql`
  mutation deleteExternalFile($externalFileId: ID!) {
    deleteExternalFile(input: { externalFileId: $externalFileId }) {
      success
    }
  }
`;
